/**
 * Stable fingerprint of rubric finding buckets for architect narrative sync (Phase G.1).
 *
 * @module client/utils/auditFindingsFingerprint
 */

const BUCKETS = ["critical", "warnings", "healthy", "inconclusive"];

/**
 * @param {unknown} findings
 * @returns {string}
 */
export function auditFindingsFingerprint(findings) {
  if (!findings || typeof findings !== "object") return "";
  const f = /** @type {Record<string, unknown>} */ (findings);
  const parts = [];
  for (const bucket of BUCKETS) {
    const arr = Array.isArray(f[bucket]) ? f[bucket] : [];
    for (const row of arr) {
      if (!row || typeof row !== "object") continue;
      const r = /** @type {{ ruleId?: string, severity?: string, detail?: string }} */ (row);
      const id = r.ruleId != null ? String(r.ruleId) : "";
      if (!id) continue;
      const detail = r.detail != null ? String(r.detail).slice(0, 80) : "";
      parts.push(`${bucket}|${id}|${detail}`);
    }
  }
  parts.sort();
  return parts.join("\n");
}
